/**
 * @file: EnergyMonitor.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 电源/水能监测配置
 */
import request from '@/utils/request'

/**
 * 电源/水能监测配置新增
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energyConfigAdd(data) {
  return request({
    type: 'device',
    url: 'energy/config/add',
    method: 'post',
    data
  })
}

/**
 * 删除电源/水能监测配置信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energyConfigDelete(data) {
  return request({
    type: 'device',
    url: 'energy/config/delete',
    method: 'post',
    data
  })
}

/**
 * 获取电源/水能监测配置信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energyConfigGet(data) {
  return request({
    type: 'device',
    url: 'energy/config/get',
    method: 'post',
    data
  })
}

/**
 * 获取电源/水能监测配置信息列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energyConfigListGet(data) {
  return request({
    type: 'device',
    url: 'energy/config/list/get',
    method: 'post',
    data
  })
}

/**
 * 电源/水能监测配置更新
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energyConfigUpdate(data) {
  return request({
    type: 'device',
    url: 'energy/config/update',
    method: 'post',
    data
  })
}

/**
 * 水能异常监测设置删除
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energySettingDelete(data) {
  return request({
    type: 'device',
    url: 'energy/setting/delete',
    method: 'post',
    data
  })
}

/**
 * 获取电能异常监测设置信息列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energySettingElecGet(data) {
  return request({
    type: 'device',
    url: 'energy/setting/elec/get',
    method: 'post',
    data
  })
}

/**
 * 电源/水能异常监测设置更新
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energySettingUpdate(data) {
  return request({
    type: 'device',
    url: 'energy/setting/update',
    method: 'post',
    data
  })
}

/**
 * 获取水能异常监测设置信息列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function energySettingWaterGet(data) {
  return request({
    type: 'device',
    url: 'energy/setting/water/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/EnergyMonitor.js